// extracted by mini-css-extract-plugin
module.exports = {"container":"_3JBQqqkMWea5j1sL5jhEgx","spinner":"_3RYhU4JQvkt1KyfMLwlQs2","smallSpinner":"v9cFLqm87nuoCBIuAji6p","avatarSpinner":"_3mj8ry8f08332YdU66evhX"};